import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { GameCollectableProjectionController } from './GameCollectableProjectionController';
import { GameLogic } from '../../../Logic/GameLogic';
import { AnimationContents } from '../../../../AnimationContents';
import { remapValue } from '../../../Common/Utils';
import { GameCollectableTypeEnum, GameModel, RoadObjectType } from '../../../Models/GameModel';

export interface IGameCollectableControllerOptions {
    type: GameCollectableTypeEnum;
    projectionController: GameCollectableProjectionController;
}


enum AnimationEnum {
    idle = 'road_xxx_idle',
    collect = 'road_xxx_collect',
}

export class GameCollectableController extends AnimationBaseController {
    $model: GameModel;

    private _projectionScale: number[] = [0.2, 6.5];

    private _type: GameCollectableTypeEnum = GameCollectableTypeEnum.none;
    private _projectionController: GameCollectableProjectionController;

    private spineData;
    private spine: PIXI.spine.Spine;
    private currentTrack;
    private currAnimation;
    private animName;
    public collected = false;


    public constructor(
        @Inject private _options: IGameCollectableControllerOptions,
        @Inject private _gameLogic: GameLogic,
    ) {
        super('GameCollectableController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.GAME_SCREEN_JSON,
            libraryName: 'collectable',
        };
    }

    protected onInitialize(): void {
        this.display["controller"] = this;
        this._type = this._options.type;
        this._projectionController = this._options.projectionController;

        this.visible = false;
        this.gotoAndStop(-1);


        switch (this._options.type) {
            case GameCollectableTypeEnum.bat:
                this.animName = 'bat';
                break;
            case GameCollectableTypeEnum.crypto:
                this.animName = 'ether';
                break;
            case GameCollectableTypeEnum.gun:
                this.animName = 'gun';
                break;
            case GameCollectableTypeEnum.horse:
                this.animName = 'uni';
                break;
        }
        this.prepareSpine();
    }

    public getObjectType(): RoadObjectType {
        return RoadObjectType.collectable;
    }

    prepareSpine() {
        // this.display.children.forEach((display)=>display.visible = false);
        const animations = Object.values(AnimationEnum);
        for (let i = 0; i < animations.length; i++) {
            //@ts-ignore
            animations[i] = animations[i].replace('xxx', this.animName);
        }


        this.spineData = this.$model.spineResources['collectables_spine']?.spineData;
        if (!this.spineData) {
            setTimeout(() => {
                this.prepareSpine();
            }, 10);
        }
        if (this.spineData)
            this.spine = new PIXI.spine.Spine(this.spineData);
        else
            console.warn('cant get spine');

        if (this.spine) {
            this.display.addChild(this.spine);

            for (const index in animations) {
                this.spine.state.addAnimation(0, animations[index], false, 0);
            }
            this.setAnimation(AnimationEnum.idle.replace('xxx', this.animName), false);
        }
    }

    onDestroy() {

        if (this.spine) {
            this.spine.autoUpdate = false;
            this.display.removeChild(this.spine);
            this.spine = null;
        }

        super.onDestroy();
    }

    protected onResize(width: number, height: number, scale: number) {
    }

    protected onUpdate(frameRate: number) {
        const globalProjectionPoint = this._projectionController.display.parent.toGlobal(this._projectionController.display.position);
        const localPoint = this.display.parent.toLocal(globalProjectionPoint, this.renderer.stage);

        this.display.x = localPoint.x;
        this.display.y = localPoint.y;
        this.display.scale.set(remapValue(globalProjectionPoint.y,
            this.renderer.renderer.height * 0.25, this.renderer.renderer.height,
            this._projectionScale[0] * GameModel.SCALE, this._projectionScale[1] * GameModel.SCALE,
        ));
    }

    public getType(): GameCollectableTypeEnum {
        return this._type;
    }

    public getIndex(): number {
        return this._projectionController.getIndex();
    }

    public getRoadIndex(): number {
        return this._projectionController.getRoadIndex();
    }

    public getProjectionController(): GameCollectableProjectionController {
        return this._projectionController;
    }

    public setAnimation(key: string, loop: boolean): void {
        if (this.spine && this.spine.state) {
            if (this.spine.state.hasAnimation(key)) {
                if (this.currAnimation !== key) {
                    this.spine.visible = true;
                    this.spine.autoUpdate = true;
                    this.spine.state.timeScale = 1;
                    this.currentTrack = this.spine.state.setAnimation(0, key, loop);
                    this.currAnimation = key;
                }
            } else {
                this.resetAnimation();
            }
        } else {
            this.resetAnimation();
        }
    }

    public resetAnimation(): void {

        this.currAnimation = '';

        if (this.spine && this.spine.state) {
            this.spine.visible = false;
            this.spine.autoUpdate = false;
            this.currentTrack = this.spine.state.setEmptyAnimation(0, 0);
        }
    }

    public collect(cb: () => void) {
        if (this.collected) return;
        this.collected = true;

        this.setAnimation(AnimationEnum.collect.replace('xxx', this.animName), false);
        let counter = 0;
        this.spine.state.addListener({
            complete: track => () => {
                if (track.animation.name == AnimationEnum.collect.replace('xxx', this.animName)) {
                    if (counter)
                        cb();
                    counter++;
                }
            },
        });
    }
}
